


























































































import { Vue, Component } from 'vue-property-decorator'
import { ColDef, ColumnApi, GridOptions } from 'ag-grid-community'

import { AgGridVue } from 'ag-grid-vue'
import Localization from '@/service/localization'
import WindowEditor from './WindowEditorVue'

import ProjectsDialog from './ProjectsDialog.vue'
import AddKeyDialog from './AddKeyDialog.vue'
import DeleteButton from './DeleteButtonVue'

  interface IRowData {
    Ключ: string
    Раздел: string
    Описание: string
    ru: string
    en: string
    de: string
    keyId: string
    projectId: string
  }

  export interface IProject {
    title: string
    section: string
    description: string
    translate: {
      ru: string
      en: string
      de: string
    }
    _id: string
    project: {
      id: string
    }
  }

@Component({
  name: 'c-localization',

  components: {
    'c-ag-grid-vue': AgGridVue,
    'c-projects-dialog': ProjectsDialog,
    'c-add-key-dialog': AddKeyDialog
  }
})
export default class LocalizationTable extends Vue {
  isEditProjects: boolean = false
  projects: any[] = []
  project: any = {}
  columnDefs: ColDef[] = []
  columnApi: ColumnApi | null = null
  rowData: IRowData[] = []
  addKeyDialogState: boolean = false
  frameworkComponents: any = null
  gridOptions: GridOptions = {
    rowHeight: 64
  }

  beforeMount (): void {
    this.frameworkComponents = {
      WindowEditor,
      DeleteButton
    }

    this.columnDefs = [
      { cellRenderer: 'DeleteButton', width: 50, cellClass: 'localization__row-remove' },
      { field: 'Ключ', editable: true },
      { field: 'Раздел', editable: true },
      { field: 'Описание', editable: true, cellEditor: 'WindowEditor' },
      { field: 'ru', editable: true, cellEditor: 'WindowEditor' },
      { field: 'en', editable: true, cellEditor: 'WindowEditor' },
      { field: 'de', editable: true, cellEditor: 'WindowEditor' }
    ]
  }

  created (): void {
    this.getProjects()
  }

  mounted (): void {
    const api = this.gridOptions.api

    if (api) {
      if (this.isColsTakesFullWidth()) {
        api.sizeColumnsToFit()
      }

      this.focusOnLeftTopCell()
    }
  }

  async handleChange (newValue: string | null): Promise<void> {
    if (typeof newValue === 'string') {
      this.project = this.projects.filter(x => {
        return x._id === newValue
      })[0]
    }

    this.getKeys()
  }

  async getKeys (): Promise<any> {
    if (this.project) {
      const req = await Localization.getKeys(this.project._id)

      this.rowData = req.map((key: IProject) => {
        return {
          Ключ: key.title,
          Раздел: key.section,
          Описание: key.description,
          ru: key.translate.ru,
          en: key.translate.en,
          de: key.translate.de,
          keyId: key._id,
          projectId: this.project._id
        }
      })
    } else {
      console.warn('Проект не найден...')
    }
  }

  getIosFile (): void {
    Localization.getIosFile(this.project._id)
  }

  getAndroidFile (): void {
    Localization.getAndroidFile(this.project._id)
  }

  getWebFile (): void {
    Localization.getWebFile(this.project._id)
  }

  async handleCellEdit (e: any): Promise<void> {
    Localization.editKey(this.project._id, e.data)
  }

  addKey (): void {
    this.addKeyDialogState = true
  }

  onGridReady (params: GridOptions): void {
    this.gridOptions.api = params.api

    if (params.columnApi) {
      this.columnApi = params.columnApi
    }
  }

  async getProjects (): Promise<void> {
    const req = await Localization.getProjects()

    this.projects = req.projects

    if (Object.keys(this.project).length === 0) {
      this.project = this.projects[0]
    } else {
      this.project = this.projects.filter(
        project => project._id === this.project._id
      )[0]
    }

    this.getKeys()
  }

  focusOnLeftTopCell (): void {
    const columnApi = this.gridOptions.columnApi
    const api = this.gridOptions.api

    if (columnApi && api) {
      let firstCol = columnApi.getAllDisplayedColumns()[0]

      api.ensureColumnVisible(firstCol)
      api.setFocusedCell(0, firstCol)
    }
  }

  isColsTakesFullWidth (): boolean | void {
    const columnApi: any = this.gridOptions.columnApi // TODO TS Column Controller type???

    if (columnApi) {
      const colsWidth = columnApi.columnModel.bodyWidth
      const awailableWidthOfGrid = (document.getElementsByClassName('ag-body-viewport')[0] as HTMLDivElement).offsetWidth

      return colsWidth < awailableWidthOfGrid
    }
  }

  onFilterTextBoxChanged() {
    const api = this.gridOptions.api

    if (api) {
      api.setQuickFilter(
        (document.getElementById('filter-text-box') as HTMLInputElement).value
      )
    }
  }
}
